import { serializeParams } from "@/utils/apiUtils";
import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpMethod } from "../../../common/api/http";
import { TwoLevelEntityIdObject, TwoLevelEntityObject } from "../../../common/types";
import { AGENT_FILTER_INCLUSION_DEFAULTS, COMMON_AGENT_FILTER_QUERY_PARAMS } from "../../agent/api";
import { CommissionPromotionType } from "./enums";
import {
  CommissionPromotion,
  CommissionPromotionFilterExportRequest,
  CommissionPromotionFilterPageRequest,
  CommissionPromotionFilterPageResult,
  UpdateCommissionPromotion,
} from "./types";

const FILTER_COMMISSION_PROMOTIONS = ApiRequestAdapter.create("/commission-promotions", HttpMethod.GET);
const APPROVE_ALL_PENDING_COMMISSION_PROMOTIONS = ApiRequestAdapter.create(
  "/commission-promotions/approve-all",
  HttpMethod.POST,
);
const UPDATE_COMMISSION_PROMOTION = ApiRequestAdapter.create("/agents/{0}/commission-promotions/{1}", HttpMethod.PUT);
const DELETE_COMMISSION_PROMOTION = ApiRequestAdapter.create(
  "/agents/{0}/commission-promotions/{1}",
  HttpMethod.DELETE,
);

const DOWNLOAD_COMMISSION_PROMOTIONS_EXPORT = ApiRequestAdapter.create("/commission-promotions/export", HttpMethod.GET);

export const commissionPromotionApi = {
  filterCommissionPromotions: (
    request: CommissionPromotionFilterPageRequest,
  ): AxiosPromise<CommissionPromotionFilterPageResult> => {
    return apiService.get(FILTER_COMMISSION_PROMOTIONS.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  approveAllPendingCommissionPromotions: (request: { type: CommissionPromotionType }): AxiosPromise<number> => {
    return apiService.post(APPROVE_ALL_PENDING_COMMISSION_PROMOTIONS.url, {}, { params: request });
  },
  updateCommissionPromotion: (
    request: TwoLevelEntityObject<UpdateCommissionPromotion>,
  ): AxiosPromise<CommissionPromotion> => {
    return apiService.put(UPDATE_COMMISSION_PROMOTION.getParametrizedUrl(request.id1, request.id2), request.object);
  },
  deleteCommissionPromotion: (request: TwoLevelEntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_COMMISSION_PROMOTION.getParametrizedUrl(request.id1, request.id2));
  },
  downloadCommissionPromotionsExport: (request: CommissionPromotionFilterExportRequest): AxiosPromise<Blob> => {
    return apiService.get(DOWNLOAD_COMMISSION_PROMOTIONS_EXPORT.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
      responseType: "blob",
    });
  },
};

export const DEFAULT_COMMISSION_PROMOTIONS_QUERY_PARAMS: Required<CommissionPromotionFilterPageRequest> = {
  ...COMMON_AGENT_FILTER_QUERY_PARAMS,
  ...AGENT_FILTER_INCLUSION_DEFAULTS.NONE_INCLUDED,
  promotionStatuses: [],
  promotionTypes: [CommissionPromotionType.LEVEL],
};
